import React, { memo } from 'react';
import { Image, StyleSheet } from 'react-native';
import { useSelector } from 'react-redux';

const Logo = () => {
  const isLightTheme = useSelector((state) => state.isLightTheme);

  return (
    <Image
      source={
        isLightTheme
          ? require('./../assets/images/logo_light.webp')
          : require('./../assets/images/logo_dark.webp')
      }
      style={styles.image}
    />
  );
};

const styles = StyleSheet.create({
  image: {
    width: 57,
    height: 65,
    marginBottom: 30,
  },
});

export default memo(Logo);
